import 'css-chunksrc/client/scenes/projectCreation/projectTypeChoice/styles.scss';export default {
  "projectTypeChoice": "_projectTypeChoice_1u80f_1",
  "header": "_header_1u80f_10",
  "title": "_title_1u80f_18",
  "subTitle": "_subTitle_1u80f_25",
  "main": "_main_1u80f_31",
  "removeIconBox": "_removeIconBox_1u80f_38",
  "removeIcon": "_removeIcon_1u80f_38",
  "choices": "_choices_1u80f_48",
  "choice": "_choice_1u80f_48",
  "iconBox": "_iconBox_1u80f_66",
  "icon": "_icon_1u80f_66",
  "column": "_column_1u80f_101",
  "name": "_name_1u80f_108",
  "description": "_description_1u80f_114"
};